<ng-container *ngIf="openCer" class="pdf-container">
    <div class="container" [ngStyle]="containerStyle">
        <pdf-viewer [src]="filePath"
            [autoresize]="true"
            [original-size]="false"
            [show-all]="true"
            [zoom]="zoomRange"
            (text-layer-rendered)="renderedPDF()"
        ></pdf-viewer>
        <ion-icon *ngIf="rendered" title="Close" class="closePDF" (click)="dismiss()" ios="close-outline" md="close-sharp"></ion-icon>
        <!-- <ion-icon class="zoom" ios="add-circle" md="add-circle" (click)="zoomIn()" ></ion-icon> -->
        <!-- <ion-icon class="zoom" ios="remove-circle" md="remove-circle" (click)="ZoomOut()" ></ion-icon> -->

        <ion-grid *ngIf="rendered" class="zoom-btn">
            <ion-row>
                <ion-col class="zoom-btn-col">
                <ion-item [disabled] = "zoomRange >= 1.4" lines="none">
                    <ion-icon ios="add-circle" md="add-circle"  (click)="zoomIn()" ></ion-icon>
                </ion-item>
                <ion-item [disabled] = "zoomRange <= 1" lines="none">
                    <ion-icon ios="remove-circle"  md="remove-circle"  (click)="zoomOut()" ></ion-icon>
                </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</ng-container>
